import { render, staticRenderFns } from "./VendorEdit_Addresses_List.vue?vue&type=template&id=08727c61&"
import script from "./VendorEdit_Addresses_List.vue?vue&type=script&lang=js&"
export * from "./VendorEdit_Addresses_List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports